import init, { ApmBase } from "@elastic/apm-rum";

import { version } from "@/../package.json";
import { IS_PRODUCTION } from "@/v1/utils/constants";

export let aleaApm: ApmBase | undefined;

export const configureApm = () => {
  if (aleaApm) return;
  aleaApm = init({
    serviceName: "cms-web",
    serviceVersion: version,
    environment: "production",
    serverUrl: "https://apm.aleaplay.com",
    distributedTracingOrigins: [/https?:\/\/[a-z0-9._-]+\.aleaplay\.com/],
    active: IS_PRODUCTION,
    breakdownMetrics: true,
  });
};
